<ng-container *transloco="let t">
  <ng-container *ngIf="showNavbar">
    <div *ngIf="offline"
      class="w-screen bg-yellow-300 flex align-items-center justify-content-center text-center pt-1 pb-1">
      <span class="material-icons-outlined">
        wifi_off
      </span>
      <p class="mb-0 mt-0 font-semibold ml-2">{{ t('offline') }}</p>
    </div>
    <div class="p-menubar p-component">
      <div class="flex justify-content-between align-items-center">
        <img (click)="router.navigate([(uid ? '/' + uid : '') + '/'])" [src]="data.logo" height="30" width="30" class="mr-2"
          [alt]="t('company_logo')" />
        <p (click)="router.navigate([(uid ? '/' + uid : '') + '/'])" class="mb-0 mt-0 ml-3 mr-3 font-semibold text-black-alpha-90 truncate">
          {{
          data.denominazione }}</p>
        <div class="flex align-items-center">
          <!-- changeLang(currentLang == 'it' ? 'en' : 'it') -->
          <span class="material-icons-outlined cursor-pointer ml-2" (click)="notificationModal['visible'] = true">
            notifications
          </span>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Message viewer -->
  <p-toast [breakpoints]="{'920px': {width: '100%', right: '0', left: '0'}}"></p-toast>

  <!-- Notification modal -->
  <p-dialog [showHeader]="false" [(visible)]="notificationModal.visible" [breakpoints]="{ '960px': '75vw' }"
    [style]="{ width: '50vw' }" [modal]="true" [draggable]="false" [resizable]="false">
    <div class="text-center">
      <h3>{{ t('notification_modal.title', {name: data.denominazione}) }}</h3>
      <p class="mb-2">{{ t('notification_modal.text', {name: data.denominazione}) }}</p>
    </div>
    <p-messages *ngIf="notificationModal.error" [value]="[{'severity': 'error', 'detail': notificationModal.error}]"
      [enableService]="false" [closable]="false"></p-messages>
    <div class="mt-1">
      <form #form="ngForm" novalidate>
        <div *ngIf="pushNotificationService.isSupported()" class="flex align-items-center">
          <p-inputSwitch [(ngModel)]="notificationModel.webpush" name="notification"></p-inputSwitch>
          <p class="ml-2 font-bold">{{ t('notification_modal.notification') }}</p>
        </div>
        <div class="hidden align-items-center">
          <p-inputSwitch [(ngModel)]="notificationModel.emailEnabled" name="emailEnabled"></p-inputSwitch>
          <p class="ml-2 font-bold">{{ t('notification_modal.email') }}</p>
        </div>
        <div *ngIf="notificationModel.emailEnabled && !uid">
          <input #email="ngModel" class="p-inputtext-sm w-full" placeholder="mario.rossi@gmail.com" type="text"
            name="email" pInputText [(ngModel)]="notificationModel.email"
            pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" required />
          <div [hidden]="(email.valid || email.pristine)" class="mt-1"><span class="text-red-500">{{
              t('form.invalid_format') }}</span></div>
        </div>
        <div *ngIf="telegram" class="mt-3">
          <a href="https://t.me/{{ telegram.replace('@', '') }}">
            <div class="flex flex-row align-items-center">
              <img src="assets/telegram.png" [alt]="t('telegram_alt_img')" width="20">
              <p class="mb-0 ml-2 mt-0 telegram-style">{{ t('notification_modal.telegram') }}</p>
            </div>
          </a>
        </div>
        <div class="mt-3" *ngIf="notificationModel.emailEnabled">
          <p-checkbox [(ngModel)]="notificationModel['privacy_consent']" [required]="true" [binary]="true"
            inputId="privacy"></p-checkbox>
          <label class="ml-2"
            [innerHTML]="t('notification_modal.privacy_tos', {link_privacy_policy: config?.link_privacy_policy})"
            for="privacy"></label>
        </div>
      </form>
      <div class="flex flex-row justify-content-end	align-items-center mt-2">
        <p-button [label]="t('ok')"
          [disabled]="!form.valid || !(!notificationModel.emailEnabled || (notificationModel.emailEnabled && notificationModel['privacy_consent'] == true))"
          [loading]="notificationModal.loading" (onClick)="notificationClick($event)"></p-button>
        <p-button class="ml-2" [label]="t('close')" severity="secondary" (onClick)="notificationModal['visible'] = false"></p-button>
      </div>
    </div>
  </p-dialog>
</ng-container>